// extracted by mini-css-extract-plugin
export default {"ToastBox":"Toast_ToastBox__2qu9b","PopUp":"Toast_PopUp__N9tDc","Check":"Toast_Check__sswfl","ToastText":"Toast_ToastText__a4LLl","Close":"Toast_Close__X3n6N"};